<template>
    <b-dropdown
        :class="classes"
        :variant="variant"
        site
        :toggle-class="toggleClasses"
        :menu-class="menuClasses"
    >
        <template v-slot:button-content>
            <slot name="buttonSlot"></slot>
        </template>
        <slot></slot>
    </b-dropdown>
</template>


<script>
export default {
    props: {
        classes: String,
        variant: String,
        site: String,
        toggleClasses: String,
        menuClasses: String
    }
}
</script>
